// extracted by mini-css-extract-plugin
export default {"image":"style_image__T+W0f","selected":"style_selected__gWSdq","mainImageContainer":"style_mainImageContainer__A9T34"};